import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee2);

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { takeLatest, put } from 'redux-saga/effects';
import { startInterdiction, workingStart, workingEnd } from 'wfui-digital-core/es/actions';
import getJson from '../../../network/get-json';
import { showStopMessage } from '../../stop-message/actions';
import getString from '../../../strings/get-string';
import { execute } from '../../../native-app-bridge/native-app-bridge';
import { NAVIGATION_REQUEST_VOICE_VERIFICATION } from '../actions';
import getVoiceVerificationPayload from './support/get-voice-verification-payload';
export default function _callee2() {
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(NAVIGATION_REQUEST_VOICE_VERIFICATION, /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
            var payload, url, _yield$getJson, biometricHubViewBean, _payload, FailureMessageBean, InterdictionViewBean, globalMessages, message, headingId;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    payload = _ref.payload;
                    url = payload.url;
                    _context.prev = 2;
                    _context.next = 5;
                    return put(workingStart());

                  case 5:
                    _context.next = 7;
                    return getJson({
                      url: url,
                      includeRootContext: false
                    });

                  case 7:
                    _yield$getJson = _context.sent;
                    biometricHubViewBean = _yield$getJson.biometricHubViewBean;
                    _payload = getVoiceVerificationPayload(biometricHubViewBean);
                    _context.next = 12;
                    return put(workingEnd());

                  case 12:
                    execute('initBioAuthenticatorManagement', _payload);
                    _context.next = 31;
                    break;

                  case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](2);
                    FailureMessageBean = _context.t0.FailureMessageBean;
                    InterdictionViewBean = _context.t0.InterdictionViewBean;
                    _context.next = 21;
                    return put(workingEnd());

                  case 21:
                    if (!InterdictionViewBean) {
                      _context.next = 26;
                      break;
                    }

                    _context.next = 24;
                    return put(startInterdiction({
                      interdiction: InterdictionViewBean,
                      postSuccessAction: NAVIGATION_REQUEST_VOICE_VERIFICATION,
                      postSuccessPayload: payload
                    }));

                  case 24:
                    _context.next = 31;
                    break;

                  case 26:
                    globalMessages = FailureMessageBean.globalMessages || [{}];
                    message = globalMessages[0].message || getString('global.service.unavailable');
                    headingId = globalMessages[0].level === 'INFORMATION' ? 'global.information' : 'global.system.unavailable.heading';
                    _context.next = 31;
                    return put(showStopMessage(message, getString(headingId)));

                  case 31:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[2, 15]]);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}